import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-action-cell-renderer',
  templateUrl: './action-cell-renderer.component.html',
  styleUrls: ['./action-cell-renderer.component.scss'],
})
export class ActionCellRendererComponent implements ICellRendererAngularComp {
  public displayValue!: any;
  showDeleteButton = true;
  showEditButton = true;
  editWithModal = false;
  appDictionary = false;
  eventRegistration = false;
  showSyncButton = false;
  showViewButton = false;
  public fieldName!: any;
  agInit(params: ICellRendererParams): void {
    this.displayValue = params;
    this.showEditButton = this.displayValue.showEditButton ?? this.showEditButton;
    this.showDeleteButton = this.displayValue.showDeleteButton ?? this.showDeleteButton;
    this.editWithModal = this.displayValue.editWithModal ?? this.editWithModal;
    this.appDictionary = this.displayValue.appDictionary ?? this.appDictionary;
    this.eventRegistration = this.displayValue.eventRegistration ?? this.eventRegistration;
    this.showSyncButton = this.displayValue.showSyncButton ?? this.showSyncButton;
    this.showViewButton = this.displayValue.showViewButton ?? this.showViewButton;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onActionClick(actionType: string, _id: string, data: any) {
    this.fieldName = data ? data.data.categoryName : '';
    this.displayValue.clicked(actionType, _id, data, this.fieldName, this.displayValue.data.avatarPath);
  }

  getEncodeValue(data: string) {
    return encodeURIComponent(data);
  }
}
